import { Container, makeStyles, Paper, Typography } from '@material-ui/core'
import { useParams } from 'react-router-dom'
import { FC, useRef, useState } from 'react'
import useTranslate from '../i18n/useTranslate'
import Form from '../component/um/setting-faculty/Form'
import { useHistory } from 'react-router-dom'
import { FacultyFormType, useSettingFaculty } from '../services/um/useSettingFaculty'
import Dialog, { DialogType } from '../control/dialog/dialog'
import useAuthenStore from '../stores/authen/authenStore'
interface SettingFacultyEditProps {}

const SettingFacultyEdit: FC<SettingFacultyEditProps> = ({}) => {
    const classes = useStyle()
    const translate = useTranslate()
    const params = useParams<{ id: string }>()
    const history = useHistory()
    const authenStore = useAuthenStore()
    const { settingFaculty, putSettingFaculty } = useSettingFaculty(params.id)

    const [configDialog, setConfigDialog] =
        useState<Pick<DialogType, 'title' | 'content' | 'type' | 'onClickConfirm' | 'onAfterClose'>>()
    const dialogTwoRef = useRef<Record<string, Function>>()
    const onRefDialogTwo = (func: Record<string, Function>) => {
        dialogTwoRef.current = func
    }

    let initialValues = {
        nameTH: settingFaculty?.nameTH ?? '',
        nameEN: settingFaculty?.nameEN ?? '',
        recID: settingFaculty?.recID ?? '0',
    }

    const save = async (values: FacultyFormType) => {
        const format = { ...values, userID: authenStore.profile.userId }
        const result = await putSettingFaculty(format, params.id)

        let optionDialog: any = {
            title: translate.get('ALERT.TITLE.NOTIFICATION'),
            content: translate.get('ALERT.CONTENT.SAVE_SUCCESS'),
            type: 'alert-message',
            onAfterClose: onBack,
        }
        if (result.status !== 1) {
            optionDialog = {
                title: translate.get('ALERT.TITLE.NOTIFICATION'),
                content: translate.get('MESSAGE.M022'),
                type: 'alert-message',
            }
        }

        setConfigDialog(optionDialog)
    }

    const onSubmit = (value: FacultyFormType) => {
        setConfigDialog({
            title: translate.get('ALERT.TITLE.NOTIFICATION'),
            content: translate.get('ALERT.CONTENT.NEED_TO_SAVE'),
            type: 'alert-confirm',
            onClickConfirm: () => save(value),
        })

        dialogTwoRef.current?.openDialog()
    }
    const onBack = () => {
        history.goBack()
    }
    return (
        <Container maxWidth="lg">
            <Typography variant="h5" style={{ fontWeight: 'bold', marginBottom: '20px' }}>
                {translate.get('UM.SETTING_FACULTY.EDIT')}
            </Typography>
            <Paper className={classes.paper}>
                <Form onBack={onBack} initialValues={initialValues} onSubmit={onSubmit} />
            </Paper>
            <Dialog onRef={onRefDialogTwo} {...configDialog} />
        </Container>
    )
}

const useStyle = makeStyles((theme) => ({
    container: {
        width: '100%',
    },
    paper: {
        width: '100%',
        padding: '20px',

        [theme.breakpoints.down('sm')]: {
            backgroundColor: 'unset',
            boxShadow: 'unset',
            margin: '0px',
        },
    },
}))

export default SettingFacultyEdit
